var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6558 53.8399C104.582 53.8399 109.386 49.0359 109.386 43.1099C109.386 37.1838 104.582 32.3799 98.6558 32.3799C92.7297 32.3799 87.9258 37.1838 87.9258 43.1099C87.9258 49.0359 92.7297 53.8399 98.6558 53.8399Z",
    fill: "#FFF385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3755 96.21C72.0855 91.24 65.8555 82.04 65.8555 71.51C65.8555 55.7 79.9055 42.88 97.2455 42.88C114.585 42.88 128.635 55.7 128.635 71.51C128.635 82.38 121.995 91.83 112.205 96.68L103.435 93.85C97.1455 95.24 91.0155 95.18 85.0355 93.85L81.3855 96.21H81.3755Z",
    fill: "#F875B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8151 49.25H64.8051C63.4651 49.25 62.4451 50.49 62.7551 51.79C63.4651 54.83 65.7251 59.8 72.8351 62.03L82.8151 49.26V49.25Z",
    fill: "#F875B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.426 93.8501L105.126 100.16C105.456 101.38 106.556 102.22 107.816 102.22H113.156C114.196 102.22 115.156 101.64 115.636 100.72L121.376 89.67L103.426 93.86V93.8501Z",
    fill: "#F875B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0262 93.8501L83.3262 100.16C82.9962 101.38 81.8962 102.22 80.6362 102.22H75.2962C74.2562 102.22 73.2962 101.64 72.8162 100.72L67.0762 89.67L85.0262 93.86V93.8501Z",
    fill: "#F875B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8152 61.2404C67.8152 61.2404 65.3752 68.9104 58.5252 71.5304C57.0852 72.0804 56.1152 73.4204 56.1152 74.9604V82.3204C56.1152 83.7404 56.9252 85.0304 58.2152 85.6204C61.6652 87.2304 68.2752 90.7204 69.5352 94.4104L86.1152 88.1804L67.8152 61.2404Z",
    fill: "#F875B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.176 69.8595H125.336C123.088 69.8595 121.266 71.6817 121.266 73.9295C121.266 76.1773 123.088 77.9995 125.336 77.9995H130.176C132.423 77.9995 134.246 76.1773 134.246 73.9295C134.246 71.6817 132.423 69.8595 130.176 69.8595Z",
    fill: "#F875B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6446 74.7601C78.0857 74.7601 80.0646 72.7812 80.0646 70.3401C80.0646 67.899 78.0857 65.92 75.6446 65.92C73.2035 65.92 71.2246 67.899 71.2246 70.3401C71.2246 72.7812 73.2035 74.7601 75.6446 74.7601Z",
    fill: "#A53065"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6143 32.42C89.4247 32.42 93.3243 28.5204 93.3243 23.71C93.3243 18.8996 89.4247 15 84.6143 15C79.8039 15 75.9043 18.8996 75.9043 23.71C75.9043 28.5204 79.8039 32.42 84.6143 32.42Z",
    fill: "#FFF385"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBank);
export default __webpack_public_path__ + "static/media/card_bank.f323af54400eaa2aaf6c453049c807d0.svg";
export { ForwardRef as ReactComponent };